import React from 'react';
import './AboutMe.css'; // Import the CSS file for styling
import student from "../../images/Student.gif";
const AboutMe = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="about-content">
             <img className="img-gif" src={student} alt="gif" />
              <h2>About Me</h2>
             <hr />
              <p>
                Hi, I am Nistha Bajracharya. I am a computer engineering student at Thapathali Campus. I have interest on frontend and data science. I am currently Code Like Her fellow and also Membership Engagement Manager (Ambassador) at Girls in Tech.
                Apart from that I love to dance, solve puzzles and sudukos. 
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;

// import React from 'react';
// import './AboutMe.css'; // Import the CSS file for styling

// const AboutMe = () => {
//   return (
//     <div className="about-container">
//       <div className="about-content">
//         <h2 className="about-heading">About Me</h2>
//         <p className="about-description">
//         Hi, I'm Nisthaa Bajracharyaa, a <strong>front-end developer</strong> specializing in React, HTML, and CSS. With a passion for creating engaging user experiences, I excel in crafting dynamic and responsive web applications. My skills blend creativity with technical precision to bring ideas to life in the digital world.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default AboutMe;
